export class CompDefinitionAvailabilities {
    public static TAB = 'TAB';
    public static ORDER_ITEM = 'ORDER_ITEM';
}
